import * as types from '../mutation-types';
import bus from '../../services/bus-event';
import {debounce} from '../../services/utility';
require('../../services/Offline');

let initialSize = getWindowSize();
let initialSizeGetted = false;

const state = {
    resolution: {
        width: initialSize.x,
        height: initialSize.y
    },
    initialResolution: {
        width: initialSize.x,
        height: initialSize.y
    },
    keyboardShown: false,
    internetOnline: false
};

function getWindowSize () {
    var w = window;
    var d = document;
    var e = d.documentElement;
    var g = d.getElementsByTagName('body')[0];
    var x = w.innerWidth || e.clientWidth || g.clientWidth;
    var y = w.innerHeight || e.clientHeight || g.clientHeight;
    return {x, y};
}

// getters
const getters = {
    resolution: state => state.resolution,
    isMobile: state => state.resolution.width < 768,
    isTablet: state => state.resolution.width >= 768 && state.resolution.width < 992,
    isDesktop: state => state.resolution.width >= 992,
    isNotLargeDesktop: sate => sate.resolution.width < 1120,
    isFacebokApp: state => window.name !== '',
    keyboardShown: state => state.keyboardShown,
    internetOnline: state => state.internetOnline
};

// actions
const actions = {
    resize () {
        let size = getWindowSize();
        state.resolution.width = size.x;
        state.resolution.height = size.y;
        if (!initialSizeGetted) {
            state.initialResolution.width = size.x;
            state.initialResolution.height = size.y;
            initialSizeGetted = true;
        }
        bus.emit('resize', state.resolution);
        actions.checkKeyboard(size.y);
    },

    checkKeyboard (height) {
        let event = 'keyboard-hidden';
        if (state.initialResolution.height > height) {
            bus.emit('keyboard-shown');
        }
        setTimeout(() => {
            bus.emit(event);
        }); // This it's because, next tick!
    },

    scrolling () {
        let realScroll = document.body.scrollHeight - state.resolution.height;
        if (document.body.scrollTop + 400 > realScroll) {
            bus.emit('scroll-bottom', state.resolution);
        }
    },

    keyboardSetVisibilityFlag (store, isShown) {
        store.commit('DEVICE_SET_KEYBOARD_VISIBILITY_FLAG', isShown);
    },
    checkIntenertConnection (store) {
        /* global Offline */
        Offline.options = {
            // Should we check the connection status immediatly on page load.
            checkOnLoad: false,
            // Should we store and attempt to remake requests which fail while the connection is down.
            requests: true,
            game: false,
            checks: {
                xhr: {
                    url: 'https://myride.com.ar/ping.php'
                }
            },
            reconnect: {
                // How many seconds should we wait before rechecking.
                initialDelay: 2
            }
        };
        console.log('Checking Offline', Offline, Offline.check());
        Offline.on('confirmed-down', function () {
            console.log('confirmed-down');
            store.commit('SET_INTERNET_STATUS', false);
        });
        Offline.on('confirmed-up', function () {
            console.log('confirmed-up');
            store.commit('SET_INTERNET_STATUS', true);
        });
    },
    confirmInternetConnection () {
        /* global Offline */
        Offline.check();
    }
};

// mutations
const mutations = {
    [types.DEVICE_DELETE] (state, id) {
        state.current = null;
    },

    'DEVICE_SET_KEYBOARD_VISIBILITY_FLAG' (state, isShown) {
        state.keyboardShown = isShown;
    },

    'SET_INTERNET_STATUS' (state, value) {
        state.internetOnline = value;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

let debounceResize = debounce(actions.resize, 300);
let debounceScroll = debounce(actions.scrolling, 300);
window.addEventListener('resize', debounceResize, true);
window.addEventListener('scroll', debounceScroll, true);



// WEBPACK FOOTER //
// ./src/store/modules/device.js